module.exports = __webpack_public_path__ + "img/yy-m1-2.fda55875.png";